import React from 'react';
import PropTypes from 'prop-types';

const UserProfile = ({ color }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1024 1024">
    <title />
    <g id="icomoon-ignore" />
    <path
      fill={color}
      d="M85.333 512c0-235.642 191.025-426.667 426.667-426.667 235.639 0 426.667 191.025 426.667 426.667 0 128.602-56.896 243.913-146.889 322.138-19.529-52.267-53.389-98.219-97.963-132.42-52.16-40.021-116.070-61.717-181.815-61.717s-129.656 21.696-181.817 61.717c-44.57 34.202-78.434 80.154-97.962 132.42-89.993-78.225-146.888-193.536-146.888-322.138zM718.063 883.452c0.175 0.653 0.363 1.297 0.567 1.933-61.218 33.95-131.665 53.282-206.63 53.282s-145.411-19.332-206.63-53.282c0.202-0.636 0.391-1.28 0.566-1.933 12.155-45.363 38.938-85.444 76.195-114.035 37.258-28.587 82.906-44.083 129.869-44.083s92.612 15.497 129.869 44.083c37.257 28.591 64.043 68.672 76.194 114.035zM426.667 384c0-47.128 38.204-85.333 85.333-85.333s85.333 38.205 85.333 85.333c0 47.13-38.204 85.333-85.333 85.333s-85.333-38.204-85.333-85.333zM512 213.333c-94.257 0-170.667 76.41-170.667 170.667 0 94.255 76.41 170.667 170.667 170.667 94.255 0 170.667-76.412 170.667-170.667 0-94.257-76.412-170.667-170.667-170.667z"
    />
    <path
      fill="none"
      strokeLinejoin="miter"
      strokeLinecap="butt"
      strokeMiterlimit="4"
      strokeWidth="42.6667"
      stroke={color}
      d="M512 106.667c223.859 0 405.333 181.474 405.333 405.333s-181.474 405.333-405.333 405.333c-223.859 0-405.333-181.474-405.333-405.333s181.474-405.333 405.333-405.333z"
    />
  </svg>
);

UserProfile.propTypes = {
  color: PropTypes.string.isRequired,
};

export default UserProfile;
